import { render, staticRenderFns } from "./cmp-mdp-data-view-panel.vue?vue&type=template&id=2f955fcc&"
import script from "./cmp-mdp-data-view-panel.vue?vue&type=script&lang=ts&"
export * from "./cmp-mdp-data-view-panel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./cmp-mdp-data-view-panel.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(component)

export default component.exports